<template>
    <div class="resumeCertificate">
        <div v-for="(n,i) in sundryList">
            <label>证书名称</label><input type="text" v-model="n.name" placeholder="请填写证书名称" @name="">
            <label>获得时间</label><input type="text" v-model="n.awardtime " placeholder="请填写获证时间">
            <label>颁发机构</label><input type="text" v-model="n.organization" placeholder="请填写颁发机构">
            <input name="sundry_id" style='border:none; font-size:0;width: 0;height: 0;' v-model="n.sundry_id">
            <input name='field' style='border:none; font-size:0;width: 0;height: 0;' value='sundry'>
            <p class="delete" v-if="i!='0'"><span @click="removeItem()">删除</span></p>
        </div>
        <p class="continue">
            <span @click="addResumeCertificate()">+继续添加</span>
            <span class="save" @click="saveSundry()">保存</span>
        </p>
    </div>
</template>

<script>
    // import {Toast} from 'mint-ui';
    export default {
        name: "resumeCertificate",
        inject: ['showMsg'],
        data:function(){
          return{
              sundryLists:[],
              certificateItemId:'0'
          }
        },
        created: function () {
        },
        methods: {
            removeItem(sundryId) {
                return this.sundryList.splice(sundryId, 1);
            },
            addResumeCertificate() {
                this.sundryLists=this.sundryList;
                this.sundryLists.push({
                    id: this.certificateItemId++,
                    name: '',
                    awardtime: '',
                    organization: '',
                    sundry_id: ''
                });
                this.$store.commit("set_sundryList",this.sundryLists);
            },
            saveSundry(){
                for(let i= 0 ; i<this.sundryList.length;i++){
                    if(this.sundryList[i].name==''){
                        this.showMsg('请填写证书名称');
                        return false;
                    }
                    if(this.sundryList[i].awardtime==''){
                        this.showMsg('请填写获证时间');
                        return false;
                    }
                    if(this.sundryList[i].organization==''){
                        this.showMsg('请填写颁发机构');
                        return false;
                    }


                }
                this.$http({
                    url: this.weburl + "/home/job/resumeHandle",
                    method: "POST",
                    dataType: "json",
                    data:{
                        arr:this.sundryList ,
                        resume_id:this.end_information,
                        field:"sundry"
                    },
                })
                    .then(res => {
                        console.log(res);
                        if (res.data.status == 1) {

                        }
                    })
                    .catch(err => {
                        console.log(err);
                    })
            }

        },
        computed: {
            sundryList: function () {
                return this.$store.state.endPage.sundryList;
            },
            end_information: function () {
                return this.$store.state.endPage.end_information;
            },
            weburl: function () {
                return this.$store.state.weburl;
            }

        }

    }
</script>

<style scoped lang="less">
    @import "../../assets/less/resume.less";

</style>
